import { DataLogin } from './autenticacion.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultadoServicio } from './lugares.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const smartHomeUrl = environment.smartHomeUrl;

@Injectable({
  providedIn: 'root'
})
export class VisitantesService {

  constructor(private _http: HttpClient) { }

  traerVisitantes(
    page: number,
    estado: number | string,
    palabrasClave: string,
    fechaInicio: string,
    horaInicio: String,
    fechaFinal: string,
    horaFinal: string,
  ): Observable<ResultadoServicio<VisitantesUnidad>> {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    let requestUrl = `${smartHomeUrl}api/visitantes/${loginData.company_id}?`;
    if (estado !== '') {
      requestUrl += `status=${estado}&`;
    }
    requestUrl += `key=${palabrasClave}&page=${page + 1}&cant=8&date_begin=${fechaInicio}&hour_begin=${horaInicio}&date_end=${fechaFinal}&hour_end=${horaFinal}`;

    requestUrl = requestUrl.replace(/(\r\n|\n|\r|\s)/gm, "");

    const headers = new HttpHeaders({
      'dataVisitantes': 'true',
      'proptech-type': loginData?.proptech_type !== undefined ? String(loginData.proptech_type) : ''
    });

    return this._http.get<ResultadoServicio<VisitantesUnidad>>(requestUrl, { headers });
  }

  traerListadoVisitas(fechaInicio: string, fechaFinal: string): Observable<any> {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    const requestUrl = `${smartHomeUrl}api/visitantes/${loginData?.company_id}?date_begin=${fechaInicio}&date_end=${fechaFinal}`;
    const headers = new HttpHeaders({
      'dataVisitantes': 'true',
      'proptech-type': loginData?.proptech_type !== undefined ? String(loginData.proptech_type) : ''
    });

    return this._http.get<any>(requestUrl, { headers });
  }

  traerVisitante(id: string) {
    const requestUrl = `${smartHomeUrl}/api/visitantes/visitante/${id}`;

    const headers = new HttpHeaders({
      'dataVisitante': 'true'
    });

    return this._http.get<ResultadoServicio<DataVisitante>>(requestUrl, { headers });
  }

  crearVisitante(visitante: Visitante) {
    const requestUrl = `${smartHomeUrl}api/visitantes/new`;

    return this._http.post<ResultadoServicio<DataVisitante>>(requestUrl, visitante);
  }

  registrarVisitante(idVisitante: string) {
    const requestUrl = `${smartHomeUrl}/api/visitantes/visitante/checking/${idVisitante}`;


    return this._http.get<ResultadoServicio<DataVisitante>>(requestUrl);
  }
}

export interface EstadoVisitante {
  nombreEstado: string;
  valorEstado: number | string | undefined;
}

export interface EstadosVisitantes {
  proptech?: string;
  estados: EstadoVisitante[];
}

export interface VisitantesUnidad {
  visitantes: Visitante[];
  estados_visitantes?: EstadosVisitantes;
}

export interface DataVisitante {
  data_visitante: Visitante
}

export interface Visitante {
  id?: number;
  user_id: number;
  name: string;
  type_document: string;
  number_document: string;
  date_checkin: Date;
  hour_checkin: string;
  hour_checkout: string;
  indicative: string;
  phone: string;
  type_vehicle: string;
  site_name: string;
  area_name: string;
  plate_vehicle: string;
  note: string;
  mark?: string;
  brand_vehicle?: string;
  status?: string;
  aut_name: string;
  type_user?: string; // 'V' = Visitante, 'C' = Contratista, 'P' = Proveedor
}

export enum TIPOS_VISITAS {
  TODOS = '',
  PENDIENTE = 1,
  ENROLADO = 2,
  ENPLANTA = 3,
  RECHAZADO = 4,
  SALIDA = 5,
  HISTORIAL = 0
}